<template>
  <div class="confirm-sign-up">
    <h2>Confirm Sign Up</h2>
    <p class="email">{{ email }}</p>
    <p>Please enter the confirmation code sent to your email:</p>
    <form @submit.prevent="confirmSignUpHandler">
      <div class="form-group">
        <label for="confirmationCode">Confirmation Code</label>
        <input type="text" id="confirmationCode" v-model="confirmationCode" required/>
      </div>
      <button type="submit" :disabled="loading">Confirm</button>
      <button type="button" class="resend-button" :disabled="resendDisabled" @click="resendConfirmationCode">
        Resend Code
      </button>
    </form>
    <p v-if="email == null" class="error-message">Email address is not set - please login first</p>
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    <p v-if="resendCountdown > 0" class="countdown">Resend code available in {{ resendCountdown }} seconds</p>
    <div v-if="showSuccessMessage" class="alert alert-success mt-3">
      <div class="success-message">
        <i class="bi bi-check-circle-fill"></i> Account confirmed successfully!
      </div>
      <div class="redirect-message">
        You may now login with your account in {{ redirectCountdown }} seconds...
      </div>
      <div class="progress redirect-progress">
        <div class="progress-bar" role="progressbar" :style="{ width: redirectProgress + '%' }"
             :aria-valuenow="redirectProgress" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  data() {
    return {
      confirmationCode: '',
      resendDisabled: false,
      showSuccessMessage: false,
      resendCountdown: 90,
      redirectCountdown: 3,
      redirectProgress: 0,
      redirectTimer: null,
    };
  },
  computed: {
    ...mapGetters('auth', ['isLoading', 'getErrorMessage', 'getEmail',]),
    loading() {
      return this.isLoading;
    },
    errorMessage() {
      return this.getErrorMessage;
    },
    email() {
      return this.getEmail;
    },
  },
  methods: {
    ...mapActions('auth', ['confirmSignUp', 'resendSignUpCode']),
    async confirmSignUpHandler() {
      try {
        const success = await this.confirmSignUp({
          email: this.email,
          code: this.confirmationCode,
        });
        if (success) {
          this.showSuccessMessage = true;
          this.startRedirectCountdown();
        }
      } catch (error) {
        console.error('Confirmation error:', error);
      }
    },
    async resendConfirmationCode() {
      const resendSuccess = await this.resendSignUpCode(this.email);
      if (!resendSuccess) {
        console.error('Failed to resend confirmation code');
      }
      console.log('Requesting new confirmation code');
      this.resendDisabled = true;
      this.resendCountdown = 90;
      this.startRedirectCountdown();
    },
    startRedirectCountdown() {
      this.redirectCountdown = 3;
      this.redirectProgress = 0;

      this.redirectTimer = setInterval(() => {
        this.redirectCountdown--;
        this.redirectProgress = (3 - this.redirectCountdown) * 33.33;

        if (this.redirectCountdown <= 0) {
          clearInterval(this.redirectTimer);
          // Keep the original ?redirect= alive so the login that follows
          // confirmation still returns the user to where they started.
          this.$router.push({name: 'Login', query: {redirect: this.$route.query.redirect}});
        }
      }, 1000);
    },
  },
  mounted() {
    if (this.email == null) {
      this.$router.push('/login');
    }
    //this.startCountdown();
  },
  beforeUnmount() {
    clearInterval(this.redirectTimer);
  }
};
</script>

<style scoped>
.confirm-sign-up {
  max-width: 420px;
  margin: clamp(24px, 6vw, 64px) auto;
  padding: 32px;
  border-radius: var(--radius);
  background: var(--card);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
}

.confirm-sign-up h2 { font-size: 26px; font-weight: 400; letter-spacing: -.01em; margin: 0 0 8px; }

.form-group {
  margin-bottom: 16px;
}

label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
}

input {
  width: 100%;
  padding: 11px 13px;
  font-size: 14px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius);
  background: var(--surface);
  color: var(--text);
  font-family: var(--font-mono);
}
input:focus { outline: none; border-color: var(--accent); box-shadow: 0 0 0 3px var(--ring); }

button {
  padding: 11px 18px;
  font-size: 14px;
  font-weight: 600;
  background: var(--accent);
  color: var(--on-accent);
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
}
button:hover:not(:disabled) { background: var(--accent-h); }
button:disabled { opacity: .6; cursor: not-allowed; }

.error-message { color: var(--danger); font-size: 13px; }

.email {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 16px;
  font-family: var(--font-mono);
  color: var(--accent);
}

.resend-button {
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--border-strong);
  margin-left: 10px;
}
.resend-button:hover:not(:disabled) { background: var(--border); }

.success-message { font-size: 16px; color: var(--success); margin-bottom: 10px; font-weight: 600; }
.redirect-message { font-size: 13px; color: var(--muted); margin-bottom: 10px; }
.redirect-progress {
  height: 8px;
  background: var(--surface);
  border-radius: var(--radius);
  overflow: hidden;
  margin-bottom: 10px;
}
.redirect-progress .progress-bar { height: 100%; background: var(--accent); }
</style>